/**
 * Authentication service for axios interceptor
 */
class AuthService {
  /**
   * Creates an AuthService with no token set.
   *
   * @returns {void}
   */
  constructor() {
    this.token = null
  }

  /**
   * Stores the current OIDC token.
   *
   * @param {string} token - Bearer token to store.
   * @returns {void}
   */
  setToken(token) {
    this.token = token
  }

  /**
   * Returns the currently stored token.
   *
   * @returns {string|null} The stored token, or `null` if none is set.
   */
  getToken() {
    return this.token
  }

  /**
   * Clears the stored token.
   *
   * @returns {void}
   */
  clearToken() {
    this.token = null
  }
}

/**
 * Shared AuthService singleton used by the axios interceptor to attach the current token.
 */
export const authService = new AuthService()
